var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('invite-user-btn',{attrs:{"account-id":_vm.parentId,"label":_vm.label,"color":"primary","loading":_vm.isLoading},on:{"invited":_vm.subscribe}})}
var staticRenderFns = []

export { render, staticRenderFns }